module.exports = __webpack_public_path__ + "img/success_icon.39725514.png";